// Français pour les trois états vides et le raccourci de zone dégradée.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Could not load': 'Impossible de charger',
  'Nothing matches': 'Rien ne correspond',
  'Nothing here yet': 'Rien ici pour le moment',
  'Nothing was written.': 'Rien n’a été écrit.',
  'Try again': 'Réessayer',
  'Clear the filter': 'Réinitialiser le filtre',
  '{zone} could not be computed': '{zone} n’a pas pu être calculé',
  'The {source} source answered: “{message}”': 'La source {source} a répondu : «{message}»',
}, 'EmptyState');
